import React from 'react';
import { Route } from 'react-router';

import { PATH } from '../constants/path';
import { DIDOMI_VENDOR_GOOGLE_ID } from '../constants';

import ModalRoot from './modal/ModalRoot';
import BannerRoot from './banner/BannerRoot';
import HeadComponent from './HeadComponent';
import RouterComponent from './router/RouterComponent';
import ScrollToTopComponent from './ScrollToTopComponent';
import AnalyticsComponent from './google/AnalyticsComponent';
import LocalizedBreadcrumbItem from './breadcrumb/LocalizedBreadcrumbsItem';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = { enableAnalytics: false };
    }

    componentDidMount() {
        if (window.Didomi) {
            const shouldEnable =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_GOOGLE_ID) || false;
            this.setState({ enableAnalytics: shouldEnable });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (window.Didomi) {
            const shouldEnable =
                window.Didomi.getUserConsentStatusForVendor(DIDOMI_VENDOR_GOOGLE_ID) || false;

            if (prevState.enableAnalytics !== shouldEnable) {
                this.setState({ enableAnalytics: shouldEnable });
            }
        }
    }

    render() {
        return (
            <div id="app">
                <AnalyticsComponent enable={this.state.enableAnalytics} />
                <HeadComponent />
                <Route component={RouterComponent} />
                <LocalizedBreadcrumbItem
                    to={PATH.HOME_PATH}
                    showBrandName></LocalizedBreadcrumbItem>
                <ModalRoot />
                <BannerRoot />
                <ScrollToTopComponent />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js